module.exports = __webpack_public_path__ + "static/media/man_typing_on_laptop.dd418227.webp";